import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { ApiBaseService } from "./api-base.service";
import { ConfigService } from "../../shared/services/config.service";
import { UserService } from "../../shared/services/user.service";

@Injectable({
  providedIn: "root"
})
export class SystemsService {
  httpOptions = { headers: new HttpHeaders({ "content-type": "application/json" }) };
  baseUrl: string;

  constructor(private configService: ConfigService, private http: HttpClient) {
    this.baseUrl = `${this.configService.config?.directUrl}/api/system`;
  }

  shouldEnforePasswordRules(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/shouldenforcepasswordrules`, this.httpOptions);
  }

  usesAzureADIntegration(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/usesazureadintegration`, this.httpOptions);
  }

  showPortalGridSections(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}/ShowPortalSections`, this.httpOptions); 
  }

  preventGetAssignments(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/Prevent_Get_Assignments`, this.httpOptions);
  }

  enableOvertimeApprovalCheck(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/EnableOvertimeApprovalCheck`, this.httpOptions);
  }

  DeviationReportShowCasedByMenu(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/Deviation_Report_Show_Cased_By_Menu`, this.httpOptions);
  }

  enableProjectPortalApprovalSupervisorSwitch(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/enableprojectportalapprovalsupervisorswitch`, this.httpOptions);
  }

  getDigitalSignatureParameters(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/GetDigitalSignatureParameters`, this.httpOptions); 
  }

  docShowSectionAttributes(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/DocShowSectionAttributes`, this.httpOptions);
  }

  getCopyTimeStatusIdFromSettings(): Observable<number> {
    return this.http.get<number>(`${this.baseUrl}/GetCopyTimeStatusIdFromSettings`, this.httpOptions);
  }
}
